export default "__VITE_ASSET__WRI9L0a8__"